import React, {useMemo} from "react";
import {ISlsOrd} from "../../../kova/slsordClient";
import {IModelConfig, IViewItemConfig} from "../../../data/IViewpoint";
import BigScreenCommunity3D, {
    BigScreen3D,
    IBigScreenCommunity3DItems,
    ICameraViewCamera,
    ICameraViewViewpoint, useCamera
} from "../../../unreal/BigScreenCommunity3D";
import {getCameraPrefixForSlsOrd} from "../../../unreal/CameraController";
import {getCameraInfo} from "../plan/GetCameraInfo";

export const SiteSpecific3DMap: React.FC<{
    lotId: string,
    modelConfig: IModelConfig,
    selectedViewItem: IViewItemConfig,
}> = (props) => {
    const { lotId, selectedViewItem} = props;

    const camera = getCameraInfo(selectedViewItem, props.modelConfig, lotId, "");
    useCamera(camera);
    return <BigScreen3D mode={"sitespecific"} />;

}